// filterModal.js — Alpine x-data factory for the list filter modal.
// Registered as Alpine.data('filterModal') so the templ only needs to
// pass initial state via data-* attributes.

export function registerFilterModal() {
  if (!window.Alpine) return;

  window.Alpine.data('filterModal', () => ({
    periodKind: '',
    from: '',
    to: '',

    init() {
      this.periodKind = this.$el.dataset.periodKind || 'month';
      this.from = this.$el.dataset.from || '';
      this.to = this.$el.dataset.to || '';
    },

    setPeriod(p) {
      this.periodKind = p;
      if (p === 'all') { this.from = ''; this.to = ''; return; }
      if (p === 'custom') { return; }
      const now = new Date();
      const y = now.getFullYear(), m = now.getMonth(), d = now.getDate();
      const iso = (yr, mo, da) => {
        const dt = new Date(Date.UTC(yr, mo, da));
        return dt.toISOString().slice(0, 10);
      };
      if (p === 'today') {
        this.from = iso(y, m, d);
        this.to = iso(y, m, d + 1);
      } else if (p === 'week') {
        const wd = now.getDay();
        const back = (wd + 6) % 7;
        this.from = iso(y, m, d - back);
        this.to = iso(y, m, d - back + 7);
      } else if (p === 'month') {
        this.from = iso(y, m, 1);
        this.to = iso(y, m + 1, 1);
      } else if (p === 'year') {
        this.from = iso(y, 0, 1);
        this.to = iso(y + 1, 0, 1);
      }
    },
  }));
}
